module.exports = __webpack_public_path__ + "static/media/payfxcom_250.15c92a41.png";